import { Controller, useFormContext } from "react-hook-form";
import { SimpleSelect } from "~/common/components/Select/SimpleSelect";
import classNames from "classnames";
import { useMemo } from "react";
import { type DropdownEntry } from "~/common/types";
import { useTranslation } from "react-i18next";

interface Props {
  className?: string;
}

export const enum OrderbookLineItemStatus {
  ALL = "all",
  NEW = "new",
  UPDATED = "updated",
  NO_CHANGE = "nochange",
}
export const OrderbookLineItemStatusEntries: DropdownEntry<string>[] = [
  {
    label: "page.abmonitor.filter.status.all",
    value: OrderbookLineItemStatus.ALL,
  },
  {
    label: "page.abmonitor.filter.status.nochange",
    value: OrderbookLineItemStatus.NO_CHANGE,
  },
  {
    label: "page.abmonitor.filter.status.new",
    value: OrderbookLineItemStatus.NEW,
  },
  {
    label: "page.abmonitor.filter.status.updated",
    value: OrderbookLineItemStatus.UPDATED,
  },
];

export const OrderLineStatusFilter = (props: Props) => {
  const formHooks = useFormContext();
  const { t } = useTranslation();

  const values = useMemo(() => {
    return OrderbookLineItemStatusEntries.map((entry) => ({ ...entry, label: t(entry.label as string) }));
  }, [t]);
  return (
    <Controller
      render={({ field: { value, onChange } }) => (
        <SimpleSelect
          label={t("page.openorders.search.orderLineStatus")}
          className={classNames(props.className)}
          fullWidth={true}
          values={values}
          value={value}
          displayEmpty={true}
          shrink={true}
          onChange={onChange}
          data-test-id={"line-status-select"}
        />
      )}
      name={"lineStatusOption"}
      control={formHooks.control}
      defaultValue={values[0].value}
    />
  );
};
